import { render, staticRenderFns } from "./GameShowConfigList.vue?vue&type=template&id=1f9f84f8&scoped=true"
import script from "./GameShowConfigList.vue?vue&type=script&lang=js"
export * from "./GameShowConfigList.vue?vue&type=script&lang=js"
import style0 from "./GameShowConfigList.vue?vue&type=style&index=0&id=1f9f84f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f84f8",
  null
  
)

export default component.exports